import { requestApi } from '../util/network'

export const createRevisedRecord = (params) => {
	const form = new FormData()
	for (const [key, value] of Object.entries(params)) {
		if (key === 'images') {
			value.forEach((v, index) => {
				form.append('images[]', v.file)
			})
		} else {
			form.append(key, value)
		}
	}
	return requestApi(
		'/orderGoodsRevisedRecord/request',
		'POST',
		form,
		'distributor',
		true
	)
}

export const getRevisedRecordByOrderId = (order_id) => {
	return requestApi(
		'/orderGoodsRevisedRecord/show',
		'GET',
		{
			order_id
		},
		'distributor'
	)
}
